import React from "react";
import PropTypes from "prop-types";
import HeaderCurve from "../gra_header_curve";
import { FormattedMessage } from "gatsby-plugin-intl";

const Common_header = ({tagline, headerTitle, description, button, image}) => {

    return (
      <section className="w-full gradient">
        <div className="flex flex-col flex-col-reverse md:flex-row pt-0 md:pt-12 px-6 text-white max-w-6xl mx-auto">
          <div className="w-full md:w-1/2">
            <p className="tracking-loose text-sm md:text-lg ">
              <FormattedMessage id={tagline} />
            </p>
            <h1 className="my-4 font-bold text-3xl md:text-5xl">
              <FormattedMessage id={headerTitle} />
            </h1>
            <p className="md:text-2xl mb-4 md:mb-6">
              <FormattedMessage id={description} />
            </p>
            <div className="flex flex-col md:flex-row">
              <div className="flex-initial w-full md:w-auto">
                {button}
              </div>
            </div>
          </div>
          <div className="w-3/4 md:w-1/2 place-self-center py-4 md:py-0">
            {image}
          </div>
        </div>
        <HeaderCurve />
      </section>
    );
}

Common_header.propTypes = {
    tagline: PropTypes.string,
    headerTitle: PropTypes.string,
    description: PropTypes.string,
    button: PropTypes.string,
    image: PropTypes.string,
};
    

export default Common_header;